import { withStyles } from '@material-ui/core/styles'
import { Slider, LinearProgress } from '@material-ui/core'

import { COLORS } from 'constants/colors'

const StyledSlider = withStyles({
  root: {
    color: '#52af77',
    height: 12,
    '& > MuiSlider-markLabel:first-child': {
      border: '1px solid red',
    },
  },
  thumb: {
    height: '42px',
    width: '42px',
    marginLeft: '-21px',
    border: '4px solid #FFFFFF',
    borderRadius: '21px',
    backgroundColor: '#5CBBDB',
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  track: {
    margin: '5px 6px',
    height: '18px',
    borderRadius: '9px',
    backgroundColor: 'rgba(55,111,139,0.2)',
  },
  rail: {
    boxSizing: 'border-box',
    height: '28px',
    border: '1px solid rgba(26,25,25,0.5)',
    borderRadius: '14px',
    backgroundColor: 'white',
  },
  mark: {},
  markLabel: {
    marginTop: '24px',
    height: '18px',
    color: '#777',
    fontFamily: 'Nunito Sans',
    fontSize: '10px',
    fontWeight: '700',
    lineHeight: '18px',
    textTransform: 'uppercase',
  },
})(Slider)

const StyledLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: 'rgba(26,25,25,0.2)',
  },
  barColorPrimary: {
    backgroundColor: `${COLORS.THEME.SECONDARY}`,
  },
})(LinearProgress)

export { StyledSlider, StyledLinearProgress }
